import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'invoiceStatusColor',

    // WARN: Use with caution!
    // Use this if the pipe should be called on value changed.
    // pure: false,
})
export class InvoiceStatusColorPipe implements PipeTransform {
    public transform(value: string): any {
        const simplifiedStatus = this.toCamelCase(value);
        const statusColor = {
            paid: 'green',
            unpaid: 'yellow',
            pastDue: 'red',
        };

        // console.log(value, simplifiedStatus, statusColor[simplifiedStatus]);
        return statusColor[simplifiedStatus] || '';
    }

    private toCamelCase(str: string): string {
        return str
            .toLowerCase()
            .replace(/[-_]+/g, ' ')  // Replace hyphens and underscores with spaces
            .replace(/[^\w\s]/g, '')  // Remove all non-word chars
            .replace(/ (.)/g, $1 => $1.toUpperCase())  // Convert start of each word to uppercase
            .replace(/ /g, '')  // Remove spaces
            .replace(/^(.)/, $1 => $1.toLowerCase());  // Convert the first character to lowercase
    }
}
